import { CHECKOUT } from '~/scopes/checkout/routes-names'
import { HOME } from '~/scopes/home/route-names'

type CheckoutStep = 'cart' | 'addresses' | 'payment' | 'insurance' | 'bouygues'

export const CHECKOUT_ACTIVE_STEPS: Record<string, CheckoutStep> = {
  [CHECKOUT.ADDRESSES]: 'addresses',
  [CHECKOUT.PAYMENT]: 'payment',
  [CHECKOUT.INSURANCE]: 'insurance',
  [CHECKOUT.SERVICES.BOUYGUES.SIGN_UP]: 'bouygues',
  [CHECKOUT.SERVICES.BOUYGUES.PHONELINE_SETUP]: 'bouygues',
}

export const CHECKOUT_PREVIOUS_ROUTES = {
  [CHECKOUT.CART]: HOME,
  [CHECKOUT.ADDRESSES]: CHECKOUT.CART,
  [CHECKOUT.PAYMENT]: CHECKOUT.ADDRESSES,
  [CHECKOUT.SERVICES.BOUYGUES.SIGN_UP]: CHECKOUT.ADDRESSES,
  [CHECKOUT.SERVICES.BOUYGUES.PHONELINE_SETUP]:
    CHECKOUT.SERVICES.BOUYGUES.SIGN_UP,
  [CHECKOUT.INSURANCE]: CHECKOUT.CART,
}
